<template>
     <v-container fluid>
    <p class="font-weight-bold title text-center">Протектор: {{user.last_name}} {{user.first_name}}</p>
    <p class="font-weight-bold title">Ваш список абитуриентов</p>
    <v-sheet>
      <v-simple-table
      :fixed-header="fixedHeader"
      :height="height"
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center">№ заявления</th>
            <th class="text-center">ФИО</th>
            <th class="text-center">№ экзамена</th>
            <th class="text-center">Видимость бланка</th>
            <th class="text-center">Действия</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in protectors_list" :key="item.id">
            <td class="text-center">{{ item.application.id }}</td>
            <td class="text-center">{{ item.application.abiturient.last_name +' '+ item.application.abiturient.first_name }}</td>
            <td class="text-center">{{ examen[item.exam] }}</td>
            <td class="text-center">
               <p v-if="item.visible === true">
                <v-icon  large color="green darken-2">{{mdiCheck}}</v-icon>
              </p>
              <p v-else>
                <v-icon large color="red darken-2">{{mdiClose}}</v-icon>
              </p>
            </td>
            <td class="text-center">
              <v-btn class="mx-2" color="primary" v-on:click="isVisible(item.id,true)">Видимая</v-btn>
              <v-btn class="mx-2" color="warning" v-on:click="isVisible(item.id,false)">Не видимая</v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
  </v-container>
</template>

<script>
   import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import { mdiCheck,mdiClose} from '@mdi/js'

  export default {
    name: "Protector",
    data: () => ({
      mdiCheck,
      mdiClose,
      fixedHeader: true,
      height: 600,
      examen:{150:'Экзамен № 1', 151:'Экзамен № 2', 152:'Экзамен № 3'},
    }),
    methods: {
      isVisible: function (id, visible) {
        Vue.axios.post('operator/protector_visible/', {id,visible})
          .then(function () {
            console.log('SUCCESS!!');
          })
          .catch(function () {
            console.log('FAILURE!!');
          });
        this.$store.dispatch('operator/loadApplicationsProtector')
      },
    },
    computed: {
      ...mapGetters("auth", ["user"]),
      ...mapGetters("operator", ["protectors_list"]),
    },
    created() {
      this.$store.dispatch('operator/loadApplicationsProtector')
    },
  };
</script>

<style scoped>

</style>
